<fgb-banner [pageTitle]="'events.page.title' | translate" />
<fgb-page-header [pageTitle]="'featured.rewards.page.title'" [backButtonLink]="'/'" />

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgbcl-marketplace-list [isList]="true" [marketplaceItemTypes]="[3, 5]" [eventItemView]="true"></fgbcl-marketplace-list>
</div>
